var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row container my-2 text-white"},[_c('div',{staticClass:"col-sm-6 info border-shadow margin-bottom"},[_c('b-icon',{staticClass:"margin-right text-color-yellow",attrs:{"icon":"exclamation-circle"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }